export const FACILITY_TAB = {
  CLEANING: 0,
  FLEET: 1,
  SCENARIOS: 2,
  HISTORY: 3,
} as const

export type FacilityTabName = 'cleaning' | 'fleet' | 'scenarios' | 'history'

const FACILITY_TAB_NAMES: FacilityTabName[] = ['cleaning', 'fleet', 'scenarios', 'history']

export function parseFacilityTab(raw: string | null | undefined): number {
  const normalized = String(raw ?? '').trim().toLowerCase()
  if (normalized === 'fleet') return FACILITY_TAB.FLEET
  if (normalized === 'scenarios') return FACILITY_TAB.SCENARIOS
  if (normalized === 'history') return FACILITY_TAB.HISTORY
  return FACILITY_TAB.CLEANING
}

export function serializeFacilityTab(tab: number): string | undefined {
  if (tab === FACILITY_TAB.CLEANING) return undefined
  return FACILITY_TAB_NAMES[tab]
}

export type StationTabName = 'status' | 'control' | 'history'

export function parseStationTab(raw: string | null | undefined): number {
  const normalized = String(raw ?? '').trim().toLowerCase()
  if (normalized === 'control') return 1
  if (normalized === 'history') return 2
  return 0
}

export function serializeStationTab(tab: number): string | undefined {
  if (tab === 1) return 'control'
  if (tab === 2) return 'history'
  return undefined
}

export type MissionControlTabName = 'details' | 'control' | 'mission'

export function parseMissionControlTab(raw: string | null | undefined): number {
  const normalized = String(raw ?? '').trim().toLowerCase()
  if (normalized === 'control') return 1
  if (normalized === 'mission') return 2
  return 0
}

export function serializeMissionControlTab(tab: number): string | undefined {
  if (tab === 1) return 'control'
  if (tab === 2) return 'mission'
  return undefined
}

export const DASHBOARD_TAB_NAMES = ['performance', 'productivity', 'completion', 'esg'] as const
export type DashboardTabName = typeof DASHBOARD_TAB_NAMES[number]

export function parseDashboardTab(raw: string | null | undefined): number {
  const normalized = String(raw ?? '').trim().toLowerCase()
  const index = DASHBOARD_TAB_NAMES.indexOf(normalized as DashboardTabName)
  return index >= 0 ? index : 0
}

export function serializeDashboardTab(tab: number): string | undefined {
  if (tab <= 0) return undefined
  return DASHBOARD_TAB_NAMES[tab]
}

export const CALENDAR_VIEW_NAMES = ['month', 'week', 'day', 'agenda'] as const
export type CalendarViewName = typeof CALENDAR_VIEW_NAMES[number]

export function parseCalendarView(raw: string | null | undefined): CalendarViewName | '' {
  const normalized = String(raw ?? '').trim().toLowerCase()
  if (normalized === 'week' || normalized === 'day' || normalized === 'agenda' || normalized === 'month') {
    return normalized
  }
  return ''
}

export function serializeCalendarView(view: CalendarViewName | ''): string | undefined {
  return view || undefined
}
